import { t } from 'i18next'

/**
 * Form constants
 */
const SUMMARY = 'summary'
const ACADEMIC_YEAR = 'academic_year'
const ACADEMIC_PERIOD = 'academic_period'
const GRADE_LEVEL = 'grade_level'
const GROUP = 'group'
const GROUP_COURSE = 'group_course'
const STUDENT = 'student'
const COURSE_COMPONENT = 'course_component'
const DATE_ASSIGNED_FROM = 'date_assigned_from'
const DATE_ASSIGNED_TO = 'date_assigned_to'

/**
 * Form model
 */
const formModel = () => {
  return {
    [SUMMARY]: {
      label: `${t('common.summary')}`,
      name: SUMMARY,
    },
    [ACADEMIC_PERIOD]: {
      label: `${t('common.academic-period')}`,
      name: ACADEMIC_PERIOD,
    }, 
    [ACADEMIC_YEAR]: {
      label: `${t('common.academic-year')}`,
      name: ACADEMIC_YEAR,
    }, 
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    }, 
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
    }, 
    [GROUP_COURSE]: {
      label: `${t('common.course')}`,
      name: GROUP_COURSE,
    },
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [COURSE_COMPONENT]: {
      label: `${t('common.course-component')}`,
      name: COURSE_COMPONENT,
    },
    [DATE_ASSIGNED_FROM]: {
      label: `${t('common.date-assigned-from')}`,
      name: DATE_ASSIGNED_FROM,
    },
    [DATE_ASSIGNED_TO]: {
      label: `${t('common.date-assigned-to')}`,
      name: DATE_ASSIGNED_TO,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SUMMARY]: false,
  [ACADEMIC_PERIOD]: null,
  [ACADEMIC_YEAR]: null,
  [GRADE_LEVEL]: null,
  [GROUP]: null,
  [GROUP_COURSE]: null,
  [STUDENT]: null,
  [COURSE_COMPONENT]: null,
  [DATE_ASSIGNED_FROM]: null,
  [DATE_ASSIGNED_TO]: null,
}

export default formModel
